import compact from 'lodash/compact';
import concat from 'lodash/concat';
import omit from 'lodash/omit';

export const appendToArray = (array, item) => {
  return compact(concat(array, item));
};

export const formatSubTicket = (val) => {
  return {
    ...omit(val, ['name_en', 'name_ar', 'abbreviation_en', 'abbreviation_ar']),
    name: { en: val.name_en, ar: val.name_ar },
    abbreviation: {
      en: val.abbreviation_en,
      ar: val.abbreviation_ar,
    },
  };
};
